import axios from './templateInstance'
import { DesignTemplateDetail } from '@/types/designTemplate'

/** Fetches one template including its design payload. */
const getDesignTemplate = async (id: string): Promise<DesignTemplateDetail | null> => {
  try {
    const response: any = await axios.get(`/design-templates/${id}`)
    return response?.data ?? null
  } catch (error) {
    console.error('Error fetching design template:', error)
    return null
  }
}

export default getDesignTemplate
